/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActorRoleResponse } from "./ActorRoleResponse";
export const ListActorRolesResponse = core.serialization.object({
    data: core.serialization.list(ActorRoleResponse),
});
